import React from 'react';
import { useSelector } from 'react-redux';
import Global from '../../../store/global-selectors';
import { messages } from './messages';

const StateComponent = ({ fulfillmentPlanId }) => {
  const { labelConfiguration, externalFulfillmentConfiguration } = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanById(state, { fulfillmentPlanId }),
  );

  const { state } = labelConfiguration?.shipTo ?? externalFulfillmentConfiguration?.shipTo ?? {};

  return state ?? '';
};

export const State = {
  getMessageDescriptor: () => messages.state,
  id: 'state',

  render: (data, { isExpanded = false, isFirstRow = true } = {}) => {
    if (isExpanded && !isFirstRow) {
      return '';
    }

    return <StateComponent fulfillmentPlanId={data.id} />;
  },
};
